import { JetView, plugins } from 'webix-jet'; // Importing JetView and plugins from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a message list view.
 * @extends JetView
 */
export default class messageListView extends JetView {
    /**
     * Configures the layout of the message list view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local identifier for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local identifier for the tab bar
                            id: 'tabbar', // Global identifier for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                // Tab options
                                {
                                    id: 'messages.messageInternal', // Identifier for internal messages tab
                                    value: _('Mensajes'), // Translated label for internal messages
                                },
                                {
                                    id: 'messages.bannerInvasive', // Identifier for invasive banner tab
                                    value: _('Banner Invasivo'), // Translated label for invasive banner
                                },
                                { id: 'messages.popup', value: _('Pop-up') }, // Identifier and label for pop-up tab
                                {
                                    id: 'messages.fringe', // Identifier for fringe tab
                                    value: _('Franja Superior'), // Translated label for fringe
                                },
                            ],
                        },
                        {
                            $subview: true, // Placeholder for subview
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the message list view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Attaching menu plugin to the tab bar
    }
}

// FILE DOCUMENTED
